module.exports = {
          srcSet: __webpack_public_path__ + "884e39144ca0e97686bccc004e3f1e85-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "884e39144ca0e97686bccc004e3f1e85-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "884e39144ca0e97686bccc004e3f1e85-60.png",
          toString:function(){return __webpack_public_path__ + "884e39144ca0e97686bccc004e3f1e85-60.png"},
          
          width: 60,
          height: 60
        }